var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.333,
    height: 16.667,
    viewBox: "0 0 13.333 16.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13034",
    "data-name": "Group 13034",
    transform: "translate(-4519.333 -1533.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M1039.753,363.03h-3.333a1.669,1.669,0,0,1-1.667-1.666v-3.333a.833.833,0,0,1,1.667,0v3.333h3.334a.833.833,0,1,1,0,1.667Z",
    transform: "translate(3492.08 1176.469)",
    fill: "#74613c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    d: "M1038.086,373.864h-8.333a2.5,2.5,0,0,1-2.5-2.5V359.7a2.5,2.5,0,0,1,2.5-2.5h5.833a.834.834,0,0,1,.589.244l4.167,4.166a.834.834,0,0,1,.244.589v9.167A2.5,2.5,0,0,1,1038.086,373.864Zm-8.333-15a.834.834,0,0,0-.834.833v11.667a.835.835,0,0,0,.834.834h8.333a.835.835,0,0,0,.834-.834v-8.822l-3.679-3.678Z",
    transform: "translate(3492.08 1176.469)",
    fill: "#74613c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_12",
    "data-name": "Line 12",
    d: "M.833.833H0A.833.833,0,0,1-.833,0,.833.833,0,0,1,0-.833H.833A.833.833,0,0,1,1.667,0,.833.833,0,0,1,.833.833Z",
    transform: "translate(4523.5 1537.833)",
    fill: "#74613c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_13",
    "data-name": "Line 13",
    d: "M5,.833H0A.833.833,0,0,1-.833,0,.833.833,0,0,1,0-.833H5A.833.833,0,0,1,5.833,0,.833.833,0,0,1,5,.833Z",
    transform: "translate(4523.5 1542.833)",
    fill: "#74613c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_14",
    "data-name": "Line 14",
    d: "M1.667.833H0A.833.833,0,0,1-.833,0,.833.833,0,0,1,0-.833H1.667A.833.833,0,0,1,2.5,0,.833.833,0,0,1,1.667.833Z",
    transform: "translate(4526.833 1546.166)",
    fill: "#74613c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCenter);
export default __webpack_public_path__ + "static/media/HelpCenter.c1d958467b21ab41a251e983b11d1b0a.svg";
export { ForwardRef as ReactComponent };